__turbopack_context__.v({
  "action": "public-landing-module__vqsRrW__action",
  "avatar": "public-landing-module__vqsRrW__avatar",
  "card": "public-landing-module__vqsRrW__card",
  "cardHeading": "public-landing-module__vqsRrW__cardHeading",
  "content": "public-landing-module__vqsRrW__content",
  "cover": "public-landing-module__vqsRrW__cover",
  "description": "public-landing-module__vqsRrW__description",
  "eyebrow": "public-landing-module__vqsRrW__eyebrow",
  "landing": "public-landing-module__vqsRrW__landing",
  "links": "public-landing-module__vqsRrW__links",
  "placeholder": "public-landing-module__vqsRrW__placeholder",
  "price": "public-landing-module__vqsRrW__price",
  "sections": "public-landing-module__vqsRrW__sections",
  "socials": "public-landing-module__vqsRrW__socials",
  "textSection": "public-landing-module__vqsRrW__textSection",
  "thumbnail": "public-landing-module__vqsRrW__thumbnail",
  "visual": "public-landing-module__vqsRrW__visual",
});
